import axios from "axios";
import { Message } from "element-ui";
import { getToken, getTokenCC, setTokenCC } from "./login";
import store from "@/store";



const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 30000, // request timeout
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  transformRequest: [
    (data) => {
      let formData = new FormData();
      for (let key in data) {
        if (Array.isArray(data[key])) {
          const values = data[key];
          if (Array.isArray(data[key])) {
            values.forEach((value, index) => {
              const newKey = `${key}[]`;
              const newValue = data[`${key}`][index];
              formData.append(newKey, newValue);
            });
          }
        } else {
          formData.append(key, data[key]);
        }
      }
      const token = getToken()
      if (token) {
        formData.append("token", token);
      }
      const tokencc = getTokenCC()
      if (tokencc) {
        formData.append("token_cc", tokencc);
      }
      return formData;
    },
  ],
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // let token = Cookies.get('Admin-Token');
    // config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

let errorCode = {
  401: "认证失败，无法访问系统资源",
  403: "当前操作没有权限",
  404: "访问资源不存在",
  default: "系统未知错误，请反馈给管理员",
};
// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode.default;
    if (code === 401) {
      Message({
        message: msg,
        dangerouslyUseHTMLString: true,
        type: "error",
      });
    } else if (code === 500) {
      Message({
        message: msg,
        dangerouslyUseHTMLString: true,
        type: "error",
      });
      return Promise.reject(new Error(msg));
    } else if (code === 403) {
      Message({
        message: msg,
        dangerouslyUseHTMLString: true,
        type: "error",
      });
      return Promise.reject(new Error(msg));
    } else if (code == 101) {
      store.dispatch('user/logout', true);
      Message({
        message: '登录失效，请重新登录',
        dangerouslyUseHTMLString: true,
        type: "error",
      });
    } else if (code !== 200) {
      const err = msg || "error";
      Message({
        message: err,
        dangerouslyUseHTMLString: true,
        type: "error",
      });
      return Promise.reject(err);
    } else {
      // console。log（res）
      // 在这打印， 只有200回家来
      return res.data;
    }
  },
  (error) => {
    Message.closeAll();
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = `系统接口${message.substr(message.length - 3)}异常`;
    }
    Message({
      message: message,
      type: "error",
      duration: 5 * 1000,
      dangerouslyUseHTMLString: true,
    });
    return Promise.reject(error);
  }
);

export default service;
